// components/ReusableMultiSelect.jsx
import React from "react";
import { Select } from "antd";
import Styles from './selectStyles.module.css';


const ReusableMultiSelect = ({
  value,
  options,
  onChange,
  placeholder = "Select options",
  maxTagPlaceholder,
  disabled = false,
  allowClear = true, // default true
  zindexValue=true,
  width='260px'
}) => {
  return (
    <div >
      <Select
        size="medium"
        mode="multiple"
        allowClear={allowClear}
        // popupClassName={zindex:zindex}


        getPopupContainer={() => document.body}
        options={options}
        style={{ width: width, fontSize: '16px' }}
        placeholder={placeholder}
        onChange={onChange}
        value={value || []}
        disabled={disabled}
        optionLabelProp="label"
        filterOption={(input, option) =>
          option?.label?.toLowerCase().includes(input.toLowerCase())
        }
        dropdownStyle={{
          zIndex: zindexValue ? 1100 : 0,
          textAlign: "left"
        }}
        
        maxTagCount={0}
        maxTagPlaceholder={maxTagPlaceholder || `${(value || []).length} selected`}
      />
    </div>

  );
};

export default ReusableMultiSelect;
